import React, { useState } from "react";
import Navbar from "../HomePage/Navbar";
import Footer from "../HomePage/Footer";
import ServicesHero from "./ServicesHero";
import ServicesGrid from "./ServicesGrid";
import ServicesProcess from "./ServicesProcess";
import ServicesComparison from "./ServicesComparison";
import ServicesFAQ from "./ServicesFAQ";
import ServicesCTA from "./ServicesCTA";

const categories = [
  { id: "all", name: "All Services" },
  { id: "management", name: "Property Management" },
  { id: "legal", name: "Legal & Documentation" },
  { id: "utility", name: "Government & Utilities" },
  { id: "interiors", name: "Painting & Furnishing" },
  { id: "trade", name: "Buy, Rent & Sell" },
];

function ServicesIndex() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <ServicesHero
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        categories={categories}
      />

      <ServicesGrid
        searchQuery={searchQuery}
        selectedCategory={selectedCategory}
      />

      <ServicesProcess />

      <ServicesComparison />

      <ServicesFAQ />

      <ServicesCTA />

      <Footer />
    </div>
  );
}

export default ServicesIndex;
